import { useDispatch } from 'react-redux';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';

import { flushState } from '~/src/entities/speed-bonus/context/actions';
import { useContextDispatch, useContextSelector } from '~/src/entities/speed-bonus/context/hooks';
import { openChat } from '~/src/store/actions/chat';

const ErrorResult = ({ onRetry }: { onRetry: () => void }): JSX.Element => {
    const dispatch = useDispatch();
    const ctxDispatch = useContextDispatch();

    const isLoading = useContextSelector(state => state.isLoading);

    const openChatHandler = () => {
        ctxDispatch(flushState());
        dispatch(openChat());
    };

    return (
        <ButtonGroup>
            <Button
                size={'large'}
                bType={'action'}
                onClick={onRetry}
                loading={isLoading}
                disabled={isLoading}
            >
                Попробовать еще раз
            </Button>
            <Button
                size={'large'}
                bType={'secondary'}
                onClick={openChatHandler}
                loading={isLoading}
                disabled={isLoading}
            >
                Написать в&nbsp;чат
            </Button>
        </ButtonGroup>
    );
};

export default ErrorResult;
